import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";

export default function AdminSettings() {
  const [s, setS] = useState(null);

  useEffect(() => { api.get("/admin/settings").then((r) => setS(r.data)).catch(() => {}); }, []);

  const setPath = (section, key, value) => setS((p) => ({ ...p, [section]: { ...p[section], [key]: value } }));

  const save = async () => {
    try { await api.put("/admin/settings", { data: s }); toast.success("Paramètres enregistrés"); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  if (!s) return <div className="text-slate-500">Chargement…</div>;

  const Group = ({ title, children }) => (
    <div className="card-dark p-6 mb-6"><h2 className="font-display font-bold text-lg mb-5">{title}</h2><div className="space-y-4">{children}</div></div>
  );
  const T = ({ section, k, label, area }) => (
    <div><label className="label-dark">{label}</label>{area
      ? <textarea rows={4} data-testid={`setting-${section}-${k}`} className="input-dark" value={s[section]?.[k] ?? ""} onChange={(e) => setPath(section, k, e.target.value)} />
      : <input data-testid={`setting-${section}-${k}`} className="input-dark" value={s[section]?.[k] ?? ""} onChange={(e) => setPath(section, k, e.target.value)} />}</div>
  );
  const N = ({ section, k, label }) => (
    <div><label className="label-dark">{label}</label><input type="number" step="any" className="input-dark" value={s[section]?.[k] ?? ""} onChange={(e) => setPath(section, k, e.target.value === "" ? "" : Number(e.target.value))} /></div>
  );

  return (
    <div data-testid="admin-settings">
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-display font-black text-3xl">Paramètres</h1>
        <button onClick={save} data-testid="save-settings-btn" className="btn-gold !py-2.5">Enregistrer</button>
      </div>

      <Group title="Réservation & Paiement">
        <div className="grid sm:grid-cols-2 gap-4">
          <N section="booking" k="lock_minutes" label="Durée du verrouillage temporaire (minutes)" />
          <N section="booking" k="vat_default" label="TVA par défaut (%)" />
          <div><label className="label-dark">Prestataire de paiement</label><input className="input-dark" value={s.booking?.payment_provider ?? "SUMUP"} onChange={(e) => setPath("booking", "payment_provider", e.target.value)} /></div>
          <label className="flex items-center gap-2 mt-7 cursor-pointer"><input type="checkbox" data-testid="setting-payment-enabled" className="accent-amber-400 w-5 h-5" checked={!!s.booking?.payment_enabled} onChange={(e) => setPath("booking", "payment_enabled", e.target.checked)} /><span className="text-sm text-slate-400">Paiement SumUp activé</span></label>
        </div>
        <p className="text-xs text-slate-600">Le montant payé à la réservation se règle par service (champ « Payé à la réservation % » : 100 % = paiement intégral, 50 % = acompte). Réservations à l'heure : 100 %. Journée : 50 %.</p>
      </Group>

      <Group title="Coordonnées du studio">
        <div className="grid sm:grid-cols-2 gap-4">
          <T section="contact" k="address" label="Adresse" />
          <T section="contact" k="phone" label="Téléphone" />
          <T section="contact" k="whatsapp" label="WhatsApp (format international, ex: 33782798521)" />
          <T section="contact" k="email" label="Email" />
        </div>
        <T section="contact" k="maps" label="Lien Google Maps" />
      </Group>

      <Group title="Le Label">
        <T section="label" k="intro" label="Introduction" area />
        <T section="label" k="vision" label="Vision" area />
        <T section="label" k="activities" label="Activités" area />
        <T section="label" k="savoir_faire" label="Savoir-faire" area />
      </Group>

      <Group title="SEO">
        <T section="seo" k="title" label="Meta title" />
        <T section="seo" k="description" label="Meta description" area />
        <T section="seo" k="og_image" label="Open Graph image (URL)" />
      </Group>

      <Group title="Textes légaux (RGPD)">
        <T section="legal" k="mentions_legales" label="Mentions légales" area />
        <T section="legal" k="confidentialite" label="Politique de confidentialité" area />
        <T section="legal" k="cgv" label="CGV" area />
        <T section="legal" k="conditions_reservation" label="Conditions de réservation" area />
      </Group>
    </div>
  );
}
